export enum RouteSlug {
  HOME = '',
  PROMOTIONS = 'promocje',
  PROMOTIONS_HISTORY = 'historia-promocji',
  ADDRESS_DATA = 'dane-adresowe',
  SERVICE = 'serwis',
  REPORT_DAMAGE = 'serwis/zglos-awarie',
  PARTNER_STORES = 'sklepy-partnerskie',
  DISCOUNT_CODES = 'kody-rabatowe',
  MY_PRODUCTS = 'moje-produkty',
  LOGIN_BY_SSO = 'sso',
  PRODUCT_REGISTRATION = 'rejestracja-produktu',
  SURVEY = 'ankieta',
  SURVEYS = 'ankiety',
  NOT_FOUND_PAGE = '404',
  SITE_UNDER_CONSTRUCTION = 'prace-techniczne',
  PRIVACY_POLICY = 'polityka-prywatnosci',
  COOKIES_POLICY = 'polityka-cookies',
  EMAIL_PREVIEW = 'podglad-wiadomosci',

  // promotions
  PRODUCTS_COVERED = 'lista-produktow',
  RULES = 'zasady',
  DATA_PROCESSING = 'przetwarzanie-danych',
  FAQ = 'faq',
  WITHOUT_REGISTRATION = 'bez-rejestracji',
  PRODUCTS_REGISTRATION = 'rejestracja-produktow',

  // active
  FIVE_YEARS = '5latgwarancji',
  SATISFACTION = 'satysfakcja',
  ORCHARDISTS = 'musujaceorzezwienie',
  BUY_RATE_GAIN = 'kupocenizyskajzamica',
  MILLION_BENEFITS = 'milionkorzysci',
  A_MI_SIE_TO_OPLACA = 'amisietooplaca',

  // not active
  // BLIK = 'plytazwracasiewblik',
  // ADD_COLOR = 'dodajkolor',
  // TIME_FOR_COUPLE = 'poranapare',
}
